import * as _ from "lodash";
import { Inject, LOCALE_ID, Injectable } from "@angular/core";
import { LgLocalizationSettings } from "@logex/framework/lg-localization";
import { Dictionary } from "lodash";
import { LgLoaderService } from "@logex/framework/lg-layout";
import { ConfigService } from "./config.service";

const LANGUAGE_STORAGE_KEY = "preferedLanguage";

@Injectable()
export class AppLocalizationSettings implements LgLocalizationSettings {
    public bootstrapDone: Promise<void>;

    readonly languages: _.Dictionary<any[]> = {};

    private _preferredLanguage;
    private setReady: () => void;

    constructor(
        @Inject(LOCALE_ID) private _locale: string,
        private _lgLoaderService: LgLoaderService,
        private _config: ConfigService
    ) {
        this.bootstrapDone = new Promise(resolve => {
            this.setReady = resolve;
        });
    }

    get fallbackLanguage(): string {
        return "en-GB";
    }

    get preferredLanguage(): string {
        return this._preferredLanguage;
    }

    get availableLanguages(): string[] {
        return ["nl-NL", "en-GB"];
    }

    get locale(): string {
        return this.preferredLanguage;
    }

    get currency(): string {
        return "EUR";
    }

    get userPreferedLanguage(): string {
        return localStorage.getItem(LANGUAGE_STORAGE_KEY);
    }

    init(): void {
        if (this._config.isLocalOrTestEnvironment) {
            this.initUserLanguage();
        } else {
            this._preferredLanguage = this._locale;
        }
        this.setReady();
    }

    deleteUserPreferedLanguage(): void {
        localStorage.removeItem(LANGUAGE_STORAGE_KEY);
    }

    saveUserPreferedLanguage(lang: string): void {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
    }

    addStrings(lang: string, strings: Dictionary<any>): void {
        this.languages[lang] = [strings];
    }

    setPreferredLanguage(lang: string): void {
        this._preferredLanguage = lang;

        if (this._config.isLocalOrTestEnvironment) {
            this.saveUserPreferedLanguage(lang);
        }
    }

    switchCurrentLanguage(lang: string): void {
        if (this._config.isLocalOrTestEnvironment) {
            this._lgLoaderService.show();
            this.setPreferredLanguage(lang);
            window.location.reload();
        }
    }

    private initUserLanguage(): void {
        if (this.userPreferedLanguage) {
            if (this.availableLanguages.includes(this.userPreferedLanguage)) {
                this._preferredLanguage = this.userPreferedLanguage;
            } else {
                this.deleteUserPreferedLanguage();
            }
        } else {
            this._preferredLanguage = this._locale;
        }
    }
}
